import type { ContactImportErrorKind } from '~~/app/contact/import/contact-import';
import type { ContactType } from '~~/app/contact/enums/ContactType';

export default function useContactImportTracking() {
    const { $tracker } = useNuxtApp();

    const trackValidationStarted = (contactType: ContactType) => {
        $tracker.track('contact_import_validation_started', {
            contact_type: contactType,
        });
    };

    const trackValidationFailed = (contactType: ContactType, errorKind: ContactImportErrorKind, errorsCount: number) => {
        $tracker.track('contact_import_validation_failed', {
            contact_type: contactType,
            error_kind: errorKind,
            errors_count: errorsCount,
        });
    };

    const trackValidationSucceeded = (contactType: ContactType) => {
        $tracker.track('contact_import_validation_succeeded', {
            contact_type: contactType,
        });
    };

    return { trackValidationStarted, trackValidationFailed, trackValidationSucceeded };
}
